import { apiList } from "../api/apiList";
import axiosInstance from "../api/axiosInstance";
import axiosInstance2 from "../api/axiosInstance2";

const differentOddService = {
  getDifferentOdd: (selectedDate) => axiosInstance.get(`${apiList.differentOddApi}/${selectedDate}`),
  getOddHistory: (payload) => axiosInstance.get(`${apiList.differentOddHistoryApi}`,{params : {id : payload.id,selectedDate : payload.selectedDate}}),
  getOddHubData: (selectedDate) => axiosInstance.get(`${apiList.getOddHubApi}/${selectedDate}`),
  getOddHubMovement: ({ eventId, selectedDate }) =>
    axiosInstance.get(`${apiList.getOddHubMovementApi}/${eventId}/${selectedDate}`)
}

export default differentOddService;
